import {Eventify} from './Eventify.js';
import {Templates} from './Templates.js';

export class SubscriptionForm {
	constructor(script, parent) {
		this.scriptUrl = new URL(script.src);
		[this.el, this.$] = Templates('SubscriptionForm');
		Eventify(this.el, this);
		parent.appendChild(this.el);		
		// return this.showResults(`You are subscribed. We'll keep you updated.`,`oops`,false);

	}
	fetchUrl() {
		let r = `${this.scriptUrl.protocol}//${this.scriptUrl.host}`;
		
		return r + "/api/subscribers";
	}
	subscribe(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		let submit = {
			name: this.$.name.value,
			email: this.$.email.value,
		}
		this.showWorking(true);
		console.log(`fetchUrl = `, this.fetchUrl());
		fetch( this.fetchUrl(), {
			method: `POST`,
			headers: { "Content-Type": `application/json` },
			body: JSON.stringify(submit)
		}).then( res=>res.json() )
		.then(res=>{
			console.log(`result of subscribe = `, res);
			return this.showResults(`<p>We've sent a confirmation email to <span>${this.$.email.value}</span>.</p>
				<p>Please check your email to confirm your subscription.</p>
				<p>If nothing arrives, please check your Spam folder.</p>`);

		}).catch(err => {
			return this.showResults(`Sorry. Something went wrong. Please try again later`, err, true);
		});
	}
	showResults(message, data=``, err=false) {
		this.$.header.innerText = err ? `Something went wrong` : `Subscribed`;
		this.$.message.innerHTML = message;
		if (data) {
			this.$.info.innerText = data;
		}
		this.$.results.classList[ err ? `add`:`remove` ](`error`);
		this.showResult(true);
	}
	classVisible(el, visible) {
		el.classList[visible ? 'add':'remove']('visible');
	}
	showWorking(show) {
		this.classVisible(this.$.inputs, !show);
		this.classVisible(this.$.working, show);
		this.classVisible(this.$.results, false);
	}
	showResult(show) {
		this.classVisible(this.$.inputs, !show);
		this.classVisible(this.$.working, false);
		this.classVisible(this.$.results, show);
	}
	closeResults(evt) {
		if (evt) {
			evt.preventDefault();
			evt.stopPropagation();
		}
		this.$.name.value=``;
		this.$.email.value=``;
		this.showResult(false);
	}
	static init(script) {
		for (let e of document.querySelectorAll(`[data-instance="ListmonkSubscriptionForm"]`)) {
			new SubscriptionForm(script, e);
		}
	}
}
